export function monitorFPS(): Promise<number> {
  return new Promise((resolve) => {
    const lastFrameTime = performance.now()
    let frameCount = 0

    function update() {
      const now = performance.now()
      frameCount++
      const delta = now - lastFrameTime

      if (delta >= 1000) {
        const fps = (frameCount / delta) * 1000
        resolve(fps)
        return
      }

      requestAnimationFrame(update)
    }

    requestAnimationFrame(update)
  })
}

export function monitorRAM(): Promise<{ usedJSHeapSize: number; totalJSHeapSize: number }> {
  return new Promise((resolve, reject) => {
    if (performance && (performance as any).memory) {
      const memory = (performance as any).memory
      resolve({
        usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
        totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
      })
    } else {
      reject(new Error('Memory API is not supported in this environment.'))
    }
  })
}
